module.exports = __webpack_public_path__ + "img/28.b2defc89.jpg";